import { render, staticRenderFns } from "./OwnClassTeacherNewForm.vue?vue&type=template&id=1264e0f1"
import script from "./OwnClassTeacherNewForm.vue?vue&type=script&lang=js"
export * from "./OwnClassTeacherNewForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports